export const gif_QuaiLogo = {
    path: 'https://firebasestorage.googleapis.com/v0/b/quai-md-km.appspot.com/o/assets%2Fquai-logo.gif?alt=media&token=5700454d-d6da-42f5-b9b1-373bcfe00675',
    alt: 'Quai Logo',
    lazyLoad: true,
};
//# sourceMappingURL=assets.js.map